import React from "react";

export default function StandardSection({ children, title, className = "" }) {
  return (
    <section
      className={`container w-full md:max-w-4xl my-8 px-6 md:px-8 mx-auto text-xl text-gray-800 leading-normal ${className}`}
    >
      {title && (
        <h1 className="uppercase text-center text-5xl text-primary pb-8">
          {title}
        </h1>
      )}
      {children}
    </section>
  );
}
